import type { Tile } from "./generals-board-model";

export const simulationRows = 18;
export const simulationColumns = 18;
export type GridPosition = { readonly x: number; readonly y: number };
export function simulationIndex({ x, y }: GridPosition): number {
  return y * simulationColumns + x;
}
export function simulationNeighbors({ x, y }: GridPosition): GridPosition[] {
  const positions = [
    { x: x + 1, y },
    { x: x - 1, y },
    { x, y: y + 1 },
    { x, y: y - 1 },
  ];
  return positions.filter(
    (point) =>
      point.x >= 0 &&
      point.x < simulationColumns &&
      point.y >= 0 &&
      point.y < simulationRows,
  );
}
export function boardTile({
  tiles,
  index,
}: {
  readonly tiles: readonly Tile[];
  readonly index: number;
}): Tile {
  const tile = tiles[index];

  if (tile === undefined)
    throw new RangeError(`Board tile ${index} is out of bounds`);

  return tile;
}
